import React from 'react';
import { Button, Modal, Table } from 'react-bootstrap';

export default function SpilloverModal({ show, onClose, date, submissions = [] }) {
    return <Modal show={show} onHide={onClose} size="xl" scrollable aria-labelledby="spillover-title">
        <Modal.Header closeButton><Modal.Title id="spillover-title">Spillover submissions - {date}</Modal.Title></Modal.Header>
        <Modal.Body>
            <p>{submissions.length} submissions excluded from OEE. Times are Malaysia time (UTC+8).</p>
            {submissions.length === 0 ? <p>No Spillover submissions for this date.</p> :
                <div style={{ overflowX: 'auto' }} tabIndex={0} role="region" aria-label="Spillover submissions">
                    <Table bordered size="sm" className="table-no-frozen-columns" style={{ minWidth: 1000 }}>
                        <thead><tr><th>Time</th><th>Machine</th><th>Job No</th><th>Good output (pcs)</th><th>Reason</th><th>Remark</th></tr></thead>
                        <tbody>{submissions.map((row, index) => <tr key={row.id ?? index}>
                            <td>{new Date(row.timestamp).toLocaleString('en-GB', { timeZone: 'Asia/Kuala_Lumpur', hour12: true })}</td>
                            <td>{row.machine}</td><td>{row.jobOrder || '-'}</td><td>{row.actualOutput}</td>
                            <td>{row.reason}</td><td>{row.remark || '-'}</td>
                        </tr>)}</tbody>
                    </Table>
                </div>}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={onClose}>Close</Button></Modal.Footer>
    </Modal>;
}
